import { nativeIsArray } from './_setup.js';
import tagTester from './_tagTester.js';

// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
export default nativeIsArray || tagTester('Array');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isArray.js
// module id = 69
// module chunks = 115